import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

const sections = [
  {
    title: "§1 Geltungsbereich",
    content:
      "Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen SPDB Studio (nachfolgend \"Auftragnehmer\") und seinen Kunden (nachfolgend \"Auftraggeber\") über die Erstellung von digitalen Branding-Lösungen für Immobilien. Abweichende Bedingungen des Auftraggebers werden nur dann Vertragsbestandteil, wenn der Auftragnehmer diesen ausdrücklich und schriftlich zugestimmt hat.",
  },
  {
    title: "§2 Leistungsumfang & Technische Hoheit",
    content:
      "Der Auftragnehmer erstellt eine individuelle Objekt-Webseite (\"Single Property Website\") gemäss dem schriftlich vereinbarten Angebot.\n\nExklusivität & Zugriff: Die technische Verwaltung, das Hosting und die Pflege der Webseite verbleiben ausschliesslich beim Auftragnehmer. Ein direkter Zugriff des Auftraggebers auf das Content-Management-System (CMS) oder den Quellcode ist aus Gründen der Design-Qualitätssicherung ausgeschlossen.",
  },
  {
    title: "§3 Urheberrecht & Nutzungsrechte",
    content:
      "Alle Rechte an den erstellten Designs, Layouts, Texten, Fotos, Videos und Codes verbleiben beim Auftragnehmer.\n\nDer Auftraggeber erhält ein zeitlich befristetes, einfaches Nutzungsrecht für das spezifische Immobilienobjekt. Dieses Recht endet mit dem Verkauf des Objekts oder nach maximal 12 Monaten, sofern nicht anders vereinbart.\n\nDie Webseite darf nicht für andere Objekte kopiert oder an Dritte übertragen werden. Der Auftragnehmer behält sich das Recht vor, die erstellten Arbeiten in seinem Portfolio und seinen Referenzen zu verwenden.",
  },
  {
    title: "§4 Mitwirkungspflicht des Auftraggebers",
    content:
      "Der Auftraggeber stellt alle notwendigen Inhalte (Texte, Grundrisse, hochauflösende Fotos) rechtzeitig und vollständig zur Verfügung. Der Auftraggeber garantiert, dass er über die entsprechenden Urheberrechte an den gelieferten Materialien verfügt.\n\nVerzögerungen, die auf fehlender oder verspäteter Mitwirkung des Auftraggebers beruhen, gehen nicht zu Lasten des Auftragnehmers.",
  },
  {
    title: "§5 Abnahme & Korrekturen",
    content:
      "Das Projekt umfasst zwei Korrekturschleifen nach Präsentation des ersten Entwurfs. Korrekturen sind innerhalb von 7 Werktagen schriftlich mitzuteilen.\n\nZusätzliche Änderungswünsche nach der finalen Abnahme werden nach Aufwand gesondert verrechnet. Geschmackliche Differenzen nach vertragsgemässer Umsetzung begründen keinen Anspruch auf Nichtzahlung oder Auftragsrückgabe.",
  },
  {
    title: "§6 Preise & Zahlungskonditionen",
    content:
      "Es gelten die im individuellen Angebot festgelegten Preise in Schweizer Franken (CHF), zuzüglich gesetzlicher Mehrwertsteuer, sofern nicht anders angegeben.\n\nRechnungen sind innerhalb von 10 Tagen ab Rechnungsdatum rein netto zahlbar. Der Auftragnehmer behält sich vor, eine Anzahlung von 50 % vor Projektbeginn zu verlangen. Bei Zahlungsverzug können Verzugszinsen von 5 % p.a. berechnet werden.",
  },
  {
    title: "§7 Laufzeit & Hosting",
    content:
      "Die Webseite wird nach Projektabschluss und vollständiger Zahlung live geschaltet. Das Hosting ist für den Zeitraum der Vermarktung (maximal 12 Monate) im Paketpreis enthalten.\n\nNach Ablauf dieser Frist kann die Laufzeit gegen eine monatliche Gebühr verlängert werden. Bei Nichtverkauf und Nichtweiterführung wird die Webseite vom Netz genommen.",
  },
  {
    title: "§8 Haftungsausschluss",
    content:
      "Der Auftragnehmer haftet nicht für die Richtigkeit der vom Auftraggeber gelieferten Objektdaten (Flächen, Preise, Beschreibungen etc.). Für technische Ausfälle der Hosting-Plattform (Dritter) wird keine Haftung übernommen.\n\nDie Haftung für leichte Fahrlässigkeit ist, soweit gesetzlich zulässig, ausgeschlossen. Die Haftung ist in jedem Fall auf den Wert des jeweiligen Auftrags begrenzt.",
  },
  {
    title: "§9 Gerichtsstand",
    content:
      "Es gilt ausschliesslich Schweizer Recht unter Ausschluss des internationalen Privatrechts. Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesem Vertrag ist der Sitz des Auftragnehmers ([Dein Wohnort]), Schweiz.\n\nSollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein, berührt dies die Wirksamkeit der übrigen Bestimmungen nicht.\n\nStand: März 2026",
  },
];

export default function AgbPage() {
  return (
    <>
      <title>AGB – Allgemeine Geschäftsbedingungen | SPDB Studio Zürich</title>
      <meta name="robots" content="noindex, nofollow" />
      <main className="min-h-screen bg-white">
        <Navbar />

        <section className="pt-48 pb-16 px-8 lg:px-16 bg-warm-white">
          <div className="max-w-2xl mx-auto text-center">
            <p className="section-label mb-6">Rechtliches</p>
            <h1 className="font-serif text-5xl text-text-primary font-medium leading-tight mb-6">
              Allgemeine Geschäfts&shy;bedingungen
            </h1>
            <span className="gold-divider mb-8" />
            <p className="font-sans font-light text-text-secondary text-sm leading-relaxed">
              Letzte Aktualisierung: März 2026
            </p>
          </div>
        </section>

        <section className="py-24 px-8 lg:px-16">
          <div className="max-w-2xl mx-auto flex flex-col gap-12">
            {sections.map((sec) => (
              <div key={sec.title}>
                <h2 className="font-serif text-2xl text-text-primary font-medium mb-5">{sec.title}</h2>
                <p className="font-sans font-light text-text-secondary text-sm leading-relaxed whitespace-pre-line">
                  {sec.content}
                </p>
              </div>
            ))}

            <div className="h-px bg-light-gray" />

            <div className="mt-4 flex flex-col sm:flex-row items-start sm:items-center gap-6">
              <Link
                to="/datenschutz"
                className="inline-flex items-center gap-2 text-xs tracking-luxury font-sans text-gold uppercase hover:opacity-70 transition-opacity duration-300"
              >
                <i className="ri-arrow-right-line" />
                Datenschutzerklärung
              </Link>
              <Link
                to="/impressum"
                className="inline-flex items-center gap-2 text-xs tracking-luxury font-sans text-gold uppercase hover:opacity-70 transition-opacity duration-300"
              >
                <i className="ri-arrow-right-line" />
                Impressum
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}
